import { render, staticRenderFns } from "./my-insurance.vue?vue&type=template&id=7c72e97e&scoped=true"
import script from "./my-insurance.vue?vue&type=script&lang=js"
export * from "./my-insurance.vue?vue&type=script&lang=js"
import style0 from "./my-insurance.vue?vue&type=style&index=0&id=7c72e97e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c72e97e",
  null
  
)

export default component.exports